import {styled} from "@mui/material/styles";
import {DialogActions} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";

export const MuiDataGrid = styled(DataGrid)(({ theme }) => ({
    color: theme.palette.text.mui,
    boxShadow: 2,
    border: 'none',
    fontSize:'small',
    fontWeight:'normal',
    textAlign: 'center',
    '& .MuiDataGrid-cell:hover': {
        color: theme.palette.primary.light,
        cursor: 'pointer'
    },
    '& .MuiDataGrid-cell:focus': {
        outlineColor: theme.palette.primary.light,
        border:2,
        shadow:''
    },
    '& .MuiToolbar-root':{
        color:theme.palette.text.main,
        fontSize: 'small',
        fontWeight: 700,
    },
    '& .MuiTablePagination-selectLabel':{
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiSelect-select': {
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiTablePagination-displayedRows': {
        fontSize: 'small',
        fontWeight: 700
    },
    '& .MuiDataGrid-columnsPanelRow': {
        color:theme.palette.text.main,
        backgroundColor: theme.palette.info.light,
    },

    // '& .MuiIcon-root':{
    //     color:'red'
    // },

    '& .MuiDataGrid-columnHeaders':{
        backgroundColor: theme.palette.background.default,
        color:theme.palette.primary.main,
        boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px'

    },
    '& .MuiDataGrid-columnHeaderTitle':{
        color:theme.palette.primary.main,
        fontWeight:'bold'
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent':{
        color:theme.palette.primary.main,
        fontWeight:'bold'
    },




    "& .MuiDataGrid-cell": {
        border: `1px solid ${theme.palette.background.default}`,
        // whiteSpace: 'normal !important',
        // wordWrap: 'break-word !important',
        // lineHeight: 'unset !important',
        // maxHeight: 'none !important',
        // whiteSpace: 'normal',
    },


    '& .MuiDataGrid-row': {
        maxHeight: 'none !important',
    },

    '& .MuiDataGrid-renderingZone': {
        maxHeight: 'none !important',
    },

    "& .MuiDataGrid-iconButtonContainer ": {
        button:{
            color: theme.palette.text.primary,
        }
    },


    "& .MuiDataGrid-menuIcon": {
        button:{
            color: theme.palette.text.primary
        }
    },

    " .MuiDataGrid-scrollbar--horizontal": {
        left:0,
        height:'5px'
    },

    '& ::-webkit-scrollbar':{
        width: '4px',
        left:0
    },
    '& ::-webkit-scrollbar-track':{
        background: theme.palette.background.default
    },
    '& ::-webkit-scrollbar-thumb': {
        background: theme.palette.secondary.main,
        borderRadius: '6px'
    },
    '& ::-webkit-scrollbar-thumb:hover ':{
        background: theme.palette.secondary.focus
    },

}));